module.exports = __webpack_public_path__ + "static/hero-5c2970d05a094bcb36beef08bde3bc5c.png";